export default __webpack_public_path__ + "static/cover-b3dd7111ef4b2517af69afdf96d31969.png";